<script>
import { ENV } from '../../config/env'

const EMBED_TIMEOUT_MS = 8000

export default {
    init: payload => {
        payload.grafanaUrl = ENV.GRAFANA_URL

        if (!payload.grafanaUrl) {
            payload.isLoading = false
            payload.showFallback = true
            payload.fallbackMessageKey = 'str.grafana.url.missing'
            return
        }

        payload.startEmbedTimeout()
    },
    methods: {
        startEmbedTimeout() {
            this.clearEmbedTimeout()
            this.embedTimeoutId = window.setTimeout(() => {
                if (!this.iframeLoaded) {
                    this.showFallback = true
                    this.isLoading = false
                    this.fallbackMessageKey = 'str.grafana.embed.timeout'
                }
            }, EMBED_TIMEOUT_MS)
        },
        clearEmbedTimeout() {
            if (this.embedTimeoutId) {
                window.clearTimeout(this.embedTimeoutId)
                this.embedTimeoutId = null
            }
        },
        handleIframeLoad() {
            this.iframeLoaded = true
            this.isLoading = false
            this.showFallback = false
            this.clearEmbedTimeout()
        },
        handleIframeError() {
            this.iframeLoaded = false
            this.isLoading = false
            this.showFallback = true
            this.fallbackMessageKey = 'str.grafana.embed.error'
            this.clearEmbedTimeout()
        },
        openGrafana() {
            if (this.grafanaUrl) {
                window.open(this.grafanaUrl, '_blank', 'noopener,noreferrer')
            }
        },
    },
}
</script>
